import { Skeleton } from 'antd';
import { TruncatedList } from 'components/common/truncated-list';
import type { ITripRouteProps } from './types';
import { useRouteWarehouses } from './use-route-warehouses';

export const TripRoute: React.FC<ITripRouteProps> = ({ warehousesIds }) => {
  const { routeWarehouses, isLoading } = useRouteWarehouses(warehousesIds);

  if (isLoading) {
    return <Skeleton active />;
  }

  return <TruncatedList maxVisible={3} items={routeWarehouses} renderItem={(warehouse) => warehouse?.name} />;
};
